import { render, staticRenderFns } from "./WordCounter.vue?vue&type=template&id=300e87e2&lang=html&"
import script from "./WordCounter.vue?vue&type=script&lang=js&"
export * from "./WordCounter.vue?vue&type=script&lang=js&"
import style0 from "./WordCounter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports